import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "stretch",
        minWidth: 300,
        ...webStyle({
            boxSizing: "border-box",
            userSelect: "none"
        })
    },
    buttonsContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    dotsContainer: {
        justifyContent: "center",
        alignItems: "center",
        height: 40,
        width: 40
    },
    buttonWrapper: {
        height: 40,
        width: 40
    },
    dotsText: {}
});

export default stylesheet;
